import { AfterViewInit, Component, ElementRef, Input, OnDestroy } from '@angular/core';
import { ContextualHelpNotifierService } from './../../services/contextual-help-notifier.service';

@Component({
  selector: 'boi-contextual-help-container',
  templateUrl: './contextual-help-container.component.html',
  styleUrls: ['./contextual-help-container.component.scss']
})
export class ContextualHelpContainerComponent implements OnDestroy, AfterViewInit {
  @Input() contextualHelpName: string;

  constructor(private contextualHelpNotifierService: ContextualHelpNotifierService, private el: ElementRef) {}

  private readonly focusFn = (): void => this.notifyContextualHelpChange();
  private readonly clickFn = (event): void => {
    if (!(event.target as HTMLElement).querySelector('.k-state-disabled')) {
      this.notifyContextualHelpChange();
    }
  };

  ngAfterViewInit(): void {
    const inputList = this.el.nativeElement.querySelectorAll('input, kendo-dropdownlist, textarea');
    for (const input of inputList) {
      input.addEventListener('focus', this.focusFn);
      input.addEventListener('click', this.clickFn);
    }
  }

  private notifyContextualHelpChange(): void {
    if (this.contextualHelpName) {
      this.contextualHelpNotifierService.contextualHelpChanged(this.contextualHelpName);
    }
  }

  ngOnDestroy(): void {
    const inputList = this.el.nativeElement.querySelectorAll('input, kendo-dropdownlist, textarea');
    for (const input of inputList) {
      input.removeEventListener('focus', this.focusFn);
      input.removeEventListener('click', this.clickFn);
    }
  }
}
